import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate } from 'react-router-dom';
import { Security } from '@okta/okta-react';

import store from 'state/store';
import { getOktaUserId } from 'helpers/okta-session';

import App from 'app';
import * as serviceWorker from 'service-worker';
import * as FullStory from '@fullstory/browser';

import api from 'api';

import 'helpers/polyfill';
import powerbi from 'utils/powerbi';
import 'styles/index.css';
import oktaAuth from 'utils/okta/use-okta';

const onAuthRequired = () => <Navigate to="/login" replace />;

powerbi.preload({
  type: 'report',
  embedUrl: 'https://app.powerbi.com/reportEmbed',
});

const restoreOriginalUri = async (oktaAuth, originalUri) => {
  const invalidPaths = ['/implicit', '/login'];

  const isValidRedirect =
    originalUri && !invalidPaths.some((path) => originalUri.includes(path));
  const date = new Date();

  await api.postLoginNotifyBackend().then((user) => {
    api
      .lastLoginNotify(user.data.oktaUserId, {
        ...user.data,
        lastLogin: date.toISOString(),
      })
      .finally(() => {
        window.location.replace(isValidRedirect ? originalUri : '/');
      });
  });
};

const oktaUserId = getOktaUserId();

FullStory.init({ orgId: 'o-1CBCVA-na1' });
oktaUserId && FullStory.identify(oktaUserId);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Security
        oktaAuth={oktaAuth}
        onAuthRequired={onAuthRequired}
        restoreOriginalUri={restoreOriginalUri}
      >
        <App />
      </Security>
    </BrowserRouter>
  </Provider>
);

serviceWorker.unregister();
